export const evvntEmailBlastSubscriberCounts = [2000, 5000, 10000, 20000, 50000];
